export default __webpack_public_path__ + "static/media/bg-green-active.dad62deb.png";